module.exports = __webpack_public_path__ + "static/img/7.26142de.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/4/sp/7.png
// module id = xYAN
// module chunks = 0